// This is made for the contentbuilder and hero video component

'use strict';

const $document = $(document);
const $videoContainer = $('.js-video-container');
const $videoTrigger = $('.js-video-trigger');
const $videoImage = $('.js-video-image');
const $embedContainer = $('.js-embed-container').hide();

$videoTrigger.on('click', function (e) {

    const $this = $(this);
    const $videoSrc = $this.attr('href');
    const $iframe = $this.closest($videoContainer).find('.js-embed-container').find('.js-video-iframe');
    const $hero = $this.closest('.js-hero');

    e.preventDefault();
    $this.find($videoImage).hide();
    $this.closest($videoContainer).find('.js-hero-content').hide();
    $this.closest($videoContainer).find($embedContainer).fadeIn();
    $this.closest($videoContainer).find('.js-video-close').fadeIn();
    $iframe.attr('src', $videoSrc);
    if ($hero.length){
        $hero.addClass('is-active-video');
    }
});

$('.js-video-close').on('click', function (e) {

    const $this = $(this);
    const $hero = $this.closest('.js-hero');

    e.preventDefault();
    $this.fadeOut();
    if ($hero.length){
        $hero.removeClass('is-active-video');
    }
    $this.closest($videoContainer).find($embedContainer).find('.js-video-iframe').attr('src', '');
    $this.closest($videoContainer).find($embedContainer).hide();
    $this.closest($videoContainer).find($videoImage).fadeIn();
    $this.closest($videoContainer).find('.js-hero-content').fadeIn();

});
